import Button from "@app/sharedComponents/Button/Button"
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import { ActivityIndicator, ImageBackground, ScrollView,View } from "react-native"
import HandCoins from '../../../assets/Icons/HandCoins';
import Eyeslash from '../../../assets/Icons/Eyeslash';
import FlashIcon from '../../../assets/Icons/FlashIcon';
import EmergencyFundIcon from '../../../assets/Icons/EmergencyFundIcon';
import FlightIcon from '../../../assets/Icons/FlightIcon';
import MedicalIcon from '../../../assets/Icons/MedicalIcon';
import CelebrationIcon from '../../../assets/Icons/CelebrationIcon';
import SecuredShield from '../../../assets/Icons/SecuredShield';
import GradientBackground from '../../../assets/Icons/GradientBackground';
import ROUTE from "@app/navigationApp/routes";
import { useEffect, useState } from "react";
import { endpoints } from "@app/api/apis";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import axios from "axios";
import { addRupeesCommasToNumber, FORECLOSURE_HANDLING, getDateMonthYearWithoutSuffixCommaFromEpoch } from "@app/utils";
import { showErrorSheet } from "@app/store/slices/errorSlice";
import handleApiErr from "@app/helper/handleApiErr";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import { Info } from "@app/sharedComponents/Icons/Icons";
import { LENDER_ID } from "@app/types/regix";
import Loading from "@app/sharedComponents/Loading/Loading";
import { formatIndianCurrency } from "@app/utils/utility";
import AsyncStorage from "@react-native-async-storage/async-storage";

type LoanDetails = {
    expiryDate?: number;
    actualLoanAmount?: number;
    loanDetails?: {
        actualLoanAmount?: number;
        expiryDate?: number;
        remainingTenureInDays?: number;
    }
    // Add other properties as needed
};

const InfoSection = ({ title, icon: Icon }: { title: string; icon: any }) => {
    return (
        <ThemedView 
            style={{
                borderRadius: 8,
                borderWidth: 1,
                borderColor: '#E4E7EC',
                flex: 1,
                paddingVertical: 12,
                paddingHorizontal: 8
            }}
        >
            <ThemedView style={{alignItems: 'center'}}>
                <Icon size={24} />
            </ThemedView>
            <ThemedView style={{marginTop: 4, marginHorizontal: 8}}>
                <ThemedText 
                    variant="b4r" 
                    color="text-primary" 
                    textAlign="center"
                >
                    {title}
                </ThemedText>
            </ThemedView>
        </ThemedView>
    );
};

const HowtoCloseAccount = ({navigation,route})=>{

    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const [bottomSheetData, setBottomSheetData] = useState(null);
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const [loanDetailsObj,setLoanDetailsObj] = useState<LoanDetails | null>(null);
    const [buttonLoader,setButtonLoader] = useState(false);
    const [isPageLoading,setIsPageLoading] = useState(true);
    const isLoanExpired = false;
    const dispatch = useAppDispatch()
    const getLoanDetails = ()=>{
        const url = endpoints.loanDetails + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
            setLoanDetailsObj(res?.data)
        })  
        .catch((err)=>{
            console.log('err',err)
        }).finally(()=>{
            setTimeout(()=>{setIsPageLoading(false)},500)
        })
    }

    const navigateToLegacyBajaj = async ()=>{
        await AsyncStorage.setItem('isBajajClosure', 'true');
        navigation.reset({
            routes: [{ name: ROUTE.HOME },{ name: "MF_FETCH"}],
        });
    }

    useEffect(()=>{
        if(userDetails?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() ===LENDER_ID.BAJAJ.toLowerCase()){
            // navigation.reset({
            //     routes: [{ name: ROUTE.HOME }, { name: ROUTE.OLD_FORECLOSURE }],
            // });
            navigateToLegacyBajaj()
        }
        getLoanDetails();
    }, []);

    const keepActive = ()=>{
        navigation.navigate('HOME')
    }

    const openBottomSheet = (data:any) => {
        setBottomSheetData(data)
        setIsBottomSheetVisible(true);
    };

    const closeBottomSheet = () => {
        setIsBottomSheetVisible(false);
    };

    const closeAccount = ()=>{
        setButtonLoader(true)
        const url = endpoints.foreclosureValidationAndDetails + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
           navigation.navigate(ROUTE.SELECT_CLOSE_REASON)
        })
        .catch((err)=>{
            if(handleApiErr(err)){
                const { voltErrorCode, message,statusCode,header } = err?.data;
                const transactionError = voltErrorCode === FORECLOSURE_HANDLING.UNLIEN_IN_PROCESS || voltErrorCode === FORECLOSURE_HANDLING.DISBURSAL_IN_PROCESS || voltErrorCode === FORECLOSURE_HANDLING.REPAYMENT_IN_PROCESS
                if(transactionError){
                    openBottomSheet(err?.data)
                }else{
                dispatch(showErrorSheet({
                    errorHeading:header,
                    isErrorSheetVisible : true,
                    errorMessage: message,
                    closeOnBackdropPress: true,
                    errorType:voltErrorCode || statusCode,
                    showMsgBg:true,
                    btnName: "Ok, got it!",
                }))
            }

            }
        }).finally(()=>{
            setButtonLoader(false)
        })
    }

    const onViewTransactions = ()=>{
        closeBottomSheet()
        setTimeout(()=>{
            navigation.navigate(ROUTE.TRANSACTION_SCREEN)
        }
        ,500)
    }

    if(isPageLoading){
        return <Loading/>
    }

    return(
        <>
            <PageHeaders pageName={route?.name} navigation={navigation}/> 
            <ScrollView style={{padding: 16,flex:1,backgroundColor:themeColorSet["bg-surface-primary"]}}>
                <ThemedText mt="md" mb="lg" variant="h5s" color="text-primary" textAlign="center" >You will lose out on</ThemedText>
                <ThemedView 
                    style={{
                        backgroundColor: '#F3FAF6',
                        borderWidth: 1,
                        borderRadius: 8,
                        borderColor: '#CFEADA',
                        paddingVertical: 28,
                        overflow: 'hidden',
                        position: 'relative'
                    }}
                >
                    <ThemedView 
                        top={0}
                        left={0}
                        right={0}
                        bottom={0}
                        borderRadius="sm"
                        overflow="hidden"
                        position="absolute"
                        zIndex={-1}
                    >
                        <GradientBackground/>
                    </ThemedView>
                    <ThemedView
                        style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 1,
                        }}
                    >
                        <ThemedText variant="l1" color="text-emphasis-secondary">₹</ThemedText>
                        <ThemedText variant="h1b" color="text-emphasis-secondary">{formatIndianCurrency(loanDetailsObj?.loanDetails?.actualLoanAmount || 0)}</ThemedText>
                    </ThemedView>
                    {isLoanExpired ? (
                        <ThemedView style={{ marginTop: 5, marginHorizontal: 48 }}>
                            <ThemedText variant="b3r" color="text-primary" textAlign="center">
                                {`Your account expired on ${getDateMonthYearWithoutSuffixCommaFromEpoch(loanDetailsObj?.loanDetails?.expiryDate)}`}
                            </ThemedText>
                        </ThemedView>
                    ) : (
                        <ThemedView style={{ marginTop: 5, marginHorizontal: 48, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
                            <ThemedText variant="b3r" color="text-primary" textAlign="center">
                                Which is available for
                            </ThemedText>
                            <ThemedText variant="b3b" color="text-emphasis-secondary" textAlign="center">
                                {' FREE '}
                            </ThemedText>
                            <ThemedText variant="b3r" color="text-primary" textAlign="center">
                                {`for the next ${loanDetailsObj?.loanDetails?.remainingTenureInDays} days`}
                            </ThemedText>
                        </ThemedView>
                    )}
                </ThemedView>
                <ThemedView style={{marginTop: 12, flexDirection: 'row', width: '100%'}}>
                    <InfoSection title="Flexible repayment" icon={HandCoins} />
                    <ThemedView style={{width: 16}} />
                    <InfoSection title="No hidden charges" icon={Eyeslash} />
                    <ThemedView style={{width: 16}} />
                    <InfoSection title="Instant cash" icon={FlashIcon} />
                </ThemedView>
                <ThemedText variant="h5s" color="text-primary" textAlign="center" my="lg">You can use credit line account for</ThemedText>
                <ThemedView flexDirection="row"  mb="md">
                    <ThemedView borderWidth={1} borderColor="border-primary" borderRadius="sm" flex={1} backgroundColor="bg-fill-primary" py="sm" px="md" mr="sm">
                        <MedicalIcon/>
                        <ThemedText variant="b3s" color="text-primary" mt="sm" >Medical costs</ThemedText>
                        <ThemedText variant="b4r" color="text-primary"  >Manage expenses for hospitalization, surgeries, or ongoing treatments.</ThemedText>
                    </ThemedView>
                    <ThemedView borderWidth={1} borderColor="border-primary" borderRadius="sm" flex={1} backgroundColor="bg-fill-primary" py="sm" px="md">
                        <FlightIcon/>
                        <ThemedText variant="b3s" color="text-primary" mt="sm" >Dream vacation</ThemedText>
                        <ThemedText variant="b4r" color="text-primary" >Fund your ideal getaway or destination wedding without disrupting investments.</ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView flexDirection="row"  mb="md">
                    <ThemedView borderWidth={1} borderColor="border-primary" borderRadius="sm" flex={1} backgroundColor="bg-fill-primary" py="sm" px="md" mr="sm">
                        <CelebrationIcon/>
                        <ThemedText variant="b3s" color="text-primary" mt="sm" >Occasion spends</ThemedText>
                        <ThemedText variant="b4r" color="text-primary"  >Celebrate Diwali, Eid or your wedding in style by using your credit line for gifts & travel.</ThemedText>
                    </ThemedView>
                    <ThemedView borderWidth={1} borderColor="border-primary" borderRadius="sm" flex={1} backgroundColor="bg-fill-primary" py="sm" px="md">
                        <EmergencyFundIcon/>
                        <ThemedText variant="b3s" color="text-primary" mt="sm" >Emergency funds</ThemedText>
                        <ThemedText variant="b4r" color="text-primary"  >Use your credit line to cover costs when your income stream is disrupted.</ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedText variant="h5s" color="text-primary" textAlign="center" mt="md" my="lg">Your data is safe with us</ThemedText>
                <ThemedView alignItems="center" justifyContent="center" backgroundColor="bg-fill-emphasis-primary-1" borderRadius="sm" borderWidth={1} borderColor="border-emphasis-primary" p="md" mb="md">
                    <SecuredShield/>
                    <ThemedText variant="b4s" color="text-primary" my="xs">ALL OUR LENDERS ARE </ThemedText>
                    <ThemedText variant="b4s" color="text-action-primary">REGULATED BY RBI </ThemedText>
                    <ThemedText variant="b3r" color="text-primary" my="xs" textAlign="center" mx="2xl">
                    Your collaterals are<ThemedText variant="b3s" color="text-primary"> secure, registered in your name,</ThemedText> and <ThemedText variant="b3s" color="text-primary">moving</ThemedText>  with the market
                    </ThemedText>
                </ThemedView>
            </ScrollView>
            <ThemedView p="lg" backgroundColor="bg-surface-primary" borderTopWidth={1} borderColor="border-primary" >
                <Button  size="MD" label={"Keep account active"} handlePress={keepActive} overRideStyle={{marginBottom:16}}/>
                <Button buttonLoader={buttonLoader} size="MD" type="OUTLINED" label={"I still want to close account"} handlePress={closeAccount}/>
            </ThemedView>
                <BottomSheetContainer
                isVisible={isBottomSheetVisible}
                close={closeBottomSheet}
                closeOnBackdropPress={true}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                containerStyle={{ backgroundColor: '#fefefe' }}
                >
                <ThemedView alignItems='center' justifyContent='center' p="lg">
                    <ThemedView my="sm">
                        <Info size={60} weight="fill"  color="#f9bd21"/>
                    </ThemedView>
                     <ThemedText mt="lg" variant='h5s' color='text-primary'>{bottomSheetData?.header}</ThemedText>
                    <ThemedView mt="sm" mb="2xl" backgroundColor='bg-fill-info' p="sm" borderRadius='sm' width={'100%'}>
                        <ThemedText textAlign='center' color='text-secondary' variant='b4r'>
                        {bottomSheetData?.message}
                        </ThemedText>
                    </ThemedView>
                    <Button
                    label={'View transaction details'}
                    type='OUTLINED'
                    handlePress={onViewTransactions}
                    overRideStyle={{marginBottom: 12}}
                    />
                    <Button
                    label={'Ok, got it!'}
                    type={'SOLID'}
                    handlePress={closeBottomSheet}
                    />
                </ThemedView>
            </BottomSheetContainer>
        </>
    )
}

export default HowtoCloseAccount